module.exports = __webpack_public_path__ + "static/team-oezkan-isik-avatar-170px-OberionIO-6a7821a75bedbabc99f7697e5b8f196f.jpg";